import React, { useContext, useEffect } from "react";
import { Stack, Container, Row, Col } from "react-bootstrap";
import "./DashboardSectionWrapper.css";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import SidebarMenu from "@/components/common/header/dashboard/SidebarMenu";
import {
  UnsavedChangesContext,
  UnsavedChangesProvider,
} from "./UnsavedChangesProvider";
import UnsavedChangesModal from "./UnsavedChangesModal";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
} from "@/redux/login/loginSlice";
import OtherLinkFooter from "@/components/common/footer/OtherLinkFooter";
import NewFooter from "@/components/common/footer/NewFooter";

const DashboardSectionWrapper = ({
  title,
  children,
  preContent,
  showDownloadBtn,
  handleDocDownload,
  userProfileStatus,
  showBidOrOfferToggleBtn,
  handleToggleBidOrOfferHistory,
  myBidsOrOfferToggleText = "History",
}) => {
  const dispatch = useDispatch();
  const context = useContext(UnsavedChangesContext);

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const hasUnsavedChanges = context?.hasUnsavedChanges ?? false;
  const setNextRoute = context?.setNextRoute ?? (() => {});
  const nextRoute = context?.nextRoute ?? (() => {});
  const setShowConfirmModal = context?.setShowConfirmModal ?? (() => {});
  const showConfirmModal = context?.showConfirmModal ?? false;
  const confirmNavigation = context?.confirmNavigation ?? (() => {});

  useEffect(() => {
    if (!isAuthenticated) {
      batch(() => {
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
      });
    }
  }, [isAuthenticated]);

  return (
    <>
      {/* <!-- Main Header Nav --> */}
      <Header />
      <MobileMenu />
       {preContent && <div className="our-dashbord dashbord">{preContent}</div>}
      <div className="dashboard_sidebar_menu">
        <div
          className="offcanvas offcanvas-dashboard offcanvas-start"
          tabIndex="-1"
          id="DashboardOffcanvasMenu"
          data-bs-scroll="true"
        >
          <SidebarMenu
            hasUnsavedChanges={hasUnsavedChanges}
            setNextRoute={setNextRoute}
            setShowConfirmModal={setShowConfirmModal}
          />
        </div>
      </div>
      {/* End sidebar_menu */}

      {/* Start Dashboard Navigation */}
      <div className="col-lg-12">
        <div className="dashboard_navigationbar dn db-1024">
          <div className="dropdown">
            <button
              className="dropbtn"
              data-bs-toggle="offcanvas"
              data-bs-target="#DashboardOffcanvasMenu"
              aria-controls="DashboardOffcanvasMenu"
            >
              <i className="fa fa-bars pr10"></i> Dashboard Navigation
            </button>
          </div>
        </div>
      </div>
      {/* End Dashboard Navigation */}

      <section className={
          preContent ? "our-dashbord2 dashbord2" : "our-dashbord dashbord"
        }>
        <div className="col-lg-12 maxw100flex-992">
          <div className="row">
            <div className="breadcrumb_content style2 pr0 ">
              <Stack gap={0} className="border border-1">
                <Container className="p-0">
                  <Row className="dashboard-section-title-container">
                    <Col className="d-flex align-items-center">
                      <h4 className="settings-title" tabIndex="0">{title}</h4>
                      {showBidOrOfferToggleBtn && (
                        <a
                          className="dashboard-bids-history"
                          onClick={handleToggleBidOrOfferHistory}
                        >
                          {myBidsOrOfferToggleText}
                        </a>
                      )}
                    </Col>
                    {showDownloadBtn && (
                      <>
                        {userProfileStatus === "ACTIVE" && (
                          <Col className="text-end">
                            <a
                              className="dashboard-section-child"
                              tabIndex="0"
                              onClick={handleDocDownload}
                            >
                              Download Your Information
                            </a>
                          </Col>
                        )}
                      </>
                    )}
                  </Row>
                  <div className="dashboard-section-child-container">
                    {isAuthenticated && children}
                  </div>
                </Container>
              </Stack>
            </div>
            <div className="row">
              {/* <!--Footer --> */}
              {/* <section className="footer_one home6 bg-ptrn2">
                <div className="container">
                  <div className="row">
                    <Footer hideRows={[1, 2, 3]} hideSocial={true}/>
                  </div>
                </div>
              </section> */}

              {/* <!-- Footer Bottom Area --> */}
            </div>
          </div>
        </div>
        <UnsavedChangesModal
          hasUnsavedChanges={hasUnsavedChanges}
          nextRoute={nextRoute}
          setShowConfirmModal={setShowConfirmModal}
          showConfirmModal={showConfirmModal}
          confirmNavigation={confirmNavigation}
        />
        <div className="row dashboard-footer-full-width">
    {/* <OtherLinkFooter /> */}
    <NewFooter />
</div>

      </section>
    </>
  );
};

export default DashboardSectionWrapper;
